import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import ProductrawtorawdemandEditForm from './ProductrawtorawdemandEditForm';
import ProductrawtorawdemandList from './ProductrawtorawdemandList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import ProductrawtorawdemandListView from './ProductrawtorawdemandListView'


export default function ProductrawtorawdemandDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.pharmaslice.productrawtorawdemandDashboard);
  const [ productrawtorawdemandId, setProductrawtorawdemandId] = React.useState('');
  const [reloadProductrawtorawdemandList, setReloadProductrawtorawdemandList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <ProductrawtorawdemandEditForm 
            setReloadProductrawtorawdemandList={setReloadProductrawtorawdemandList}
            productrawtorawdemandId={productrawtorawdemandId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <ProductrawtorawdemandListView 
                      setProductrawtorawdemandId = {setProductrawtorawdemandId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
